// src/components/scene/ModelTexture.tsx
import { useEffect, useMemo } from 'react';

import { useGLTF } from '@react-three/drei';
import * as THREE from 'three';

import { useAppDispatch } from '../../../hooks.ts';
import { useStore } from '../../../pages/workspace/hooks.ts';
import { loadBakedModelFile } from '../../../store/reducers/workspace.reducer.ts';

const BakedModel: React.FC<{ url: string; transformMatrix: THREE.Matrix4 }> = ({ url, transformMatrix }) => {
  const { scene } = useGLTF(url);
  const clonedScene = scene.clone();

  clonedScene.traverse((child) => {
    if (child instanceof THREE.Mesh) {
      child.applyMatrix4(transformMatrix);
    }
  });

  return <primitive object={clonedScene} position={[0, 0, 0]} />;
};

export const ModelTexture = () => {
  const dispatch = useAppDispatch();
  const { activeVersion } = useStore();
  const bakedModelUrl = activeVersion?.bakedModelUrl || null;

  const transformMatrix = useMemo(() => {
    const matrix = new THREE.Matrix4();
    matrix.set(1, 0, 0, 0, 0, 0, -1, 0, 0, 1, 0, 0, 0, 0, 0, 1);
    return matrix;
  }, []);

  useEffect(() => {
    if (!bakedModelUrl) {
      dispatch(loadBakedModelFile());
    }
  }, [dispatch, bakedModelUrl]);

  if (!bakedModelUrl) {
    return null;
  }

  return <BakedModel url={bakedModelUrl} transformMatrix={transformMatrix} />;
};
